import { Injectable } from '@angular/core';
import { Auth, signInWithEmailAndPassword, signOut, onAuthStateChanged, User, UserCredential, createUserWithEmailAndPassword, sendPasswordResetEmail } from '@angular/fire/auth';
import { BehaviorSubject, Observable } from 'rxjs'; // Import BehaviorSubject and Observable
import { first } from 'rxjs/operators'; // Import first operator

@Injectable({ providedIn: 'root' })
export class AuthService {
  private _user: User | null = null;
  private authStateResolved = new BehaviorSubject<boolean>(false); // Tracks if auth state has been resolved

  // user: User | null = null;

  constructor(private auth: Auth) {
    console.log('[AuthService] Constructor init')
    onAuthStateChanged(this.auth, (user) => {
      this._user = user;
      this.authStateResolved.next(true); // Signal that auth state is now known
      console.log('[AuthService] Constructor Firebase Auth state resolved:', user ? user.uid : 'No user');
    });
  }

  // Expose the auth state resolution as an observable
  get authReady$(): Observable<boolean> {
    return this.authStateResolved.asObservable().pipe(first(isReady => isReady === true));
  }

  signUp(email: string, password: string): Promise<UserCredential> {
    return createUserWithEmailAndPassword(this.auth, email, password);
  }

  signin(email: string, password: string) {
    return signInWithEmailAndPassword(this.auth, email, password);
  }

  signOut() {
    return signOut(this.auth);
  }

  sendPasswordReset(email: string): Promise<void> {
    return sendPasswordResetEmail(this.auth, email);
  }

  isSignedIn(): boolean {
    return !!this.auth.currentUser;
  }

  isAuthenticated(): boolean { // Checks resolved asynchronous state
    return !!this._user;
  }

  getUser(): User | null {
    return this._user;
  }
}